import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import HBModel from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { cancelSubscription, getGrocery } from "@/services";
import formatTime from "@/utils/formatTime";
import { gdSlsReportError } from "@/utils/gdSlsRum";
import useRequest from "@/utils/useReq";
import { Button, Input } from "antd";
import classNames from "classnames";
import { without } from "lodash";
import { useCallback, useState } from "react";
import { getSkuUnit } from "../shared/utils";
import styles from "./index.module.less";

export function CancelSubscribeConfirm(props) {
  const { onCancel, onOk, subscription, vip_expire, onUnSubscribe } = props;
  const [step, setStep] = useState("cancel");
  const [selected, setSelected] = useState([]);
  const [otherReason, setOtherReason] = useState();

  const sku = subscription.items[0].content;

  const durationUnit = getSkuUnit(sku);

  // 取消弹框配置信息
  const { data: conf } = useRequest(async () => {
    const conf = await getGrocery("cancel-subscription-dialog");
    return conf;
  });

  const onCancelSubscribe = useCallback(async () => {
    try {
      // 用户不想用了 给第三方的取消理由
      const res = await cancelSubscription(subscription.id, "用户不想用了");
      if (!res?.err) {
        setStep("reason");
        onUnSubscribe && onUnSubscribe();
      }
    } catch (error) {
      // if (typeof window !== "undefined" && window._SLS_) {
      //   window._SLS_.reportError(
      //     new Error("取消订阅失败:" + error)
      //   );
      // }
      gdSlsReportError(new Error("取消订阅失败:" + error.toString()));
      HBMessage.error("取消失败, 请联系客服处理");
    }
  }, [subscription, onUnSubscribe]);

  const onSelect = useCallback(
    (item) => {
      if (selected.includes(item)) {
        setSelected(without(selected, item));
      } else {
        setSelected([...selected, item]);
      }
    },
    [selected]
  );

  const onInput = useCallback((e) => {
    setOtherReason(e.target.value);
  }, []);

  if (!conf) return null;

  return (
    <HBModel
      {...props}
      footer={null}
      width={480}
      className={styles.cancelConfirm}
    >
      {step === "cancel" ? (
        <>
          <div
            className={styles.firstText}
            data-dialog-title="订阅取消确认弹框"
            data-gd-expose="dialog_expose"
          >
            ¥{sku.price}/{durationUnit}
            为限时优惠价，平台承诺自动续费期间不涨价，建议你继续保留
          </div>
          <div className={styles.secondText}>
            取消后，VIP将在{formatTime(vip_expire, "YYYY/MM/DD")}到期
          </div>
          <div className={styles.vipCard}>
            <div className={styles.border}>
              <div className={styles.title}>{sku.name}</div>
              <div className={styles.tag}>限时特惠</div>
              <div className={styles.price}>
                <div>¥{sku.price}</div>
                <div className={styles.unit}>/{durationUnit}</div>
                {sku.original_price > sku.price && (
                  <div className={styles.originPrice}>
                    ¥{sku.original_price}/{durationUnit}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <Button
              onClick={onCancelSubscribe}
              data-dialog-title="订阅取消确认弹框"
              data-dialog-action="取消订阅"
              data-gd-click="dialog_action"
            >
              坚决取消
            </Button>
            <Button
              onClick={onCancel}
              type="primary"
              data-dialog-title="订阅取消确认弹框"
              data-dialog-action="继续保留续费"
              data-gd-click="dialog_action"
            >
              继续保留
            </Button>
          </div>
        </>
      ) : (
        <>
          <div
            className={styles.firstText}
            data-dialog-title="订阅取消成功弹框"
            data-gd-expose="dialog_expose"
          >
            <HBIcon className={styles.check} type="ic_check" />
            <div className={styles.cancelText}>
              <div>已取消</div>
              <div>个人VIP将于{formatTime(vip_expire, "YYYY/MM/DD")}到期</div>
            </div>
          </div>

          <div className={styles.cancelReason}>
            <div>
              您选择取消自动续费的原因是什么呢？
              <span className={styles.mutiTag}>多选</span>
            </div>
            <div className={styles.options}>
              {conf.reasons.map((r) => (
                <div
                  key={r.text}
                  className={classNames(styles.item, {
                    [styles.active]: selected.includes(r.text),
                  })}
                  onClick={() => onSelect(r.text)}
                >
                  {r.text}
                  {selected.includes(r.text) ? <HBIcon type="ic_check" /> : ""}
                </div>
              ))}
            </div>
            <div>
              <Input.TextArea
                value={otherReason}
                className={styles.input}
                placeholder="其他原因"
                onChange={onInput}
              />
            </div>

            <div className={styles.submit}>
              <Button
                type="primary"
                data-dialog-title="订阅取消成功弹框"
                data-dialog-action="取消原因提交"
                data-gd-click="dialog_action"
                data-dialog-content={[...selected, otherReason]
                  .filter((r) => r)
                  .join()}
                onClick={onOk}
              >
                提交
              </Button>
            </div>
          </div>
        </>
      )}
    </HBModel>
  );
}

export default ModalWrap(CancelSubscribeConfirm);
